<template>
  <div>
    <div class="options flex flex-wrap gap-2">
      <div v-if="territorios.state.filteredZones.length > 0">
        <MultiSelect v-model="zonesComputed" :maxSelectedLabels="1"  :options="territorios.state.filteredZones" placeholder="Seleccione zonas a mostrar" />
      </div>
      <div>
        <MultiSelect v-model="terrComputed" :maxSelectedLabels="1" :options="territorios.state.filteredTerr" optionLabel="name" placeholder="Seleccione territorio a mostrar" />
      </div>
      <div class="flex flex-wrap gap-2">
        <ToggleButton v-model="showMza" @change="filter()" onIcon="pi pi-check" offIcon="pi pi-times"  onLabel="Manzanas" offLabel="Manzanas" />
        <ToggleButton v-model="showMzaNro" @change="filter()" onIcon="pi pi-check" offIcon="pi pi-times"  onLabel="Numeros de Manzanas" offLabel="Numeros de Manzanas" />
        <ToggleButton v-model="showCenter" @change="filter()" onIcon="pi pi-check" offIcon="pi pi-times"  onLabel="Centro Territorio" offLabel="Centro Territorio" />
        <ToggleButton v-model="showLines" @change="filter()" onIcon="pi pi-check" offIcon="pi pi-times"  onLabel="Lineas" offLabel="Lineas" />
        <ToggleButton v-model="showAlojamientos" @change="onToggleAlojamientos()" onIcon="pi pi-check" offIcon="pi pi-times" onLabel="Alojamientos" offLabel="Alojamientos" />
        <!-- <Dropdown  v-model="m.tile" :options="layers"  placeholder="Tipo de Mapa" @change="m.setTileLayer" /> -->
        <Dropdown v-model="size" :options="tamaño" optionLabel="label" optionValue="value"  placeholder="Tamaño" @change="setSize" v-if="!screen.isMobile" />
        <Button label="Ocultar" @click="emit('hide')" severity="secondary" />
      </div>

    </div>
  </div>
</template>

<script setup>
import ToggleButton from 'primevue/togglebutton';
import Dropdown from 'primevue/dropdown';
import { ref, onMounted, defineProps, watch, defineEmits, computed } from 'vue'
import { useTerritoriosStore } from "@/store/territorios";
import { useScreenStore } from '@/store/useScreenStore';
import { useAlojamientos } from '@/composables/useAlojamientos';
import Button from 'primevue/button';

const territorios = useTerritoriosStore()
const screen = useScreenStore()
const mapaBase = ref(null)


const size = ref('')

// const layers = computed({
//   get() {
//     if (!mapaBase.value) return []
//     return  mapaBase.value.m.layers
//   }
// })


const activeZones = ref([])
const activeTerr = ref([])
const tamaño = ref([
  {label:'Normal', value: '' },
  {label:'x2', value: 'height: 200vh; width: 200vw;' },
  {label:'x3', value: 'height: 300vh; width: 300vw;' },
  {label:'x4', value: 'height: 400vh; width: 400vw;' },
  {label:'x5', value: 'height: 500vh; width: 500vw;' },
])

const zonesComputed = computed({
  get() {
    return activeZones.value
  },
  set(val) {
    activeZones.value = val
    filter()
  }
})
const terrComputed = computed({
  get() {
    return activeTerr.value
  },
  set(val) {
    activeTerr.value = val
    filter()
  }
})
const showCenter = ref(false)
const tileLayer = ref(null)
const showMza = ref(true)
const showMzaNro = ref(false)
const showLines = ref(false)
const showAlojamientos = ref(false)

const alojamientosApi = useAlojamientos()
const alojamientosList = ref([])
const alojamientosLoaded = ref(false)


const emit = defineEmits(['setSize', 'hide'])
const setSize = () => {
  emit("setSize", size)
}
const map = () => mapaBase.value.m.map.value
const m = () => mapaBase.value.m
var activeGroup;
var activeMarkers;

const filter = () => {
  console.log("filter", showMza.value )
  if (activeGroup) {
    // console.log("activeGroup", activeGroup)
    activeGroup.eachLayer(l => activeGroup.removeLayer(l))
  }
  if (activeMarkers) activeMarkers.remove()
  if (activeZones.value.length === 0 && activeTerr.value.length  === 0) return;
  
  let list = [ ...territorios.list.filter(item => activeZones.value.indexOf(item.zona) >= 0 ), ...activeTerr.value ]
  let polilines = []
  let numbers = []
  for ( let i in list){
    let item = list[i]
    polilines.push(m().L.polyline([...item.limits, item.limits[0]], m().sectorOption))
    
    const zona = item.zona || ""
    if (showCenter.value){
      let center = item.mzNumbers[0][0]
      let icon = L.divIcon({
        className: 'manzana-marker ',
        iconSize:null,
        html:'<div class="icon manzana-marker-center" style="font-size: 1em">'+zona+item.numero+'</div><div class="arrow" />'
      });
      numbers.push(m().L.marker(center, { icon }))
    }

    if (showMza.value){
      const colors = (item.color) ? `color: ${item.color.color}; background: ${item.color.backgroundColor}; border: ${item.color.backgroundColor}; ` : '';
      for ( let key in item.mzNumbers){
        if (parseInt(key) === 0) continue;
        // console.log("item.center", item.center)
        let label = showMzaNro.value ? key : zona+item.numero
        let icon = L.divIcon({
          className: 'manzana-marker ',
          iconSize:null,
          html: `<div class="icon manzana-marker-center" style="font-size: 1em; ${colors}">${label}</div><div class="arrow" />`
        });
        const marker = m().L.marker(item.mzNumbers[key][0], { icon })
        numbers.push(marker)
      }
    }

    // numbers.push(m().L.marker(centerLetter, { icon: m.lIcons[item.zona.toUpperCase()] }))
  }
  
  if (showLines.value) {

    activeGroup = L.featureGroup(polilines).addTo(map());
  }
  
  const toRemoveMarker = activeMarkers;
  
  activeMarkers = m().addLayerGroup(L.layerGroup(numbers), toRemoveMarker)

  // console.log("activeMarkers", activeMarkers)
}

// Capa opcional de alojamientos (casas donde se hospedan publicadores visitantes).
// Independiente del filtro de zonas/territorios: se puede activar aunque no haya
// ninguna zona/territorio seleccionado.
var activeAlojamientos;

const escapeHtml = (s) =>
  String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))

const alojamientoIcon = () => L.divIcon({
  className: 'alojamiento-marker',
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  html: '<div style="width:30px;height:30px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);background:#16a085;border:2px solid #fff;box-shadow:0 2px 4px rgba(0,0,0,.3);display:flex;align-items:center;justify-content:center;"><i class="pi pi-home" style="transform:rotate(45deg);color:#fff;font-size:14px;"></i></div>',
})

const alojamientoPopup = (a) => {
  const persona = a.cantidad === 1 ? 'persona' : 'personas'
  const vehiculo = a.vehiculo ? ' · 🚗 con vehículo' : ''
  const whatsappHref = a.whatsapp ? String(a.whatsapp).replace(/\D/g, '') : ''
  return `
    <div style="min-width:180px">
      <strong>${escapeHtml(a.nombre)}</strong><br/>
      ${a.ubicacion ? escapeHtml(a.ubicacion) + '<br/>' : ''}
      ${a.cantidad ?? 0} ${persona}${vehiculo}
      ${whatsappHref ? `<br/><a href="https://wa.me/${whatsappHref}" target="_blank" rel="noopener">WhatsApp</a>` : ''}
    </div>
  `
}

const filterAlojamientos = () => {
  // Siempre pasa por addLayerGroup (incluso con lista vacía al desactivar) para que
  // el store de mapa desregistre correctamente la capa anterior de su ciclo de zoom.
  const toRemove = activeAlojamientos
  const icon = alojamientoIcon()
  const markers = showAlojamientos.value
    ? alojamientosList.value.filter((a) => a.lat && a.lng).map((a) => m().L.marker([a.lat, a.lng], { icon }).bindPopup(alojamientoPopup(a)))
    : []
  activeAlojamientos = m().addLayerGroup(L.layerGroup(markers), toRemove)
}

const onToggleAlojamientos = async () => {
  if (showAlojamientos.value && !alojamientosLoaded.value) {
    const result = await alojamientosApi.getAlojamientos()
    alojamientosList.value = result.alojamientos || []
    alojamientosLoaded.value = true
  }
  filterAlojamientos()
}

const setMapaBase = (mapaBaseVal) => {
  mapaBase.value = mapaBaseVal
}

defineExpose({
  filter,
  setMapaBase
})

onMounted(() => {
  activeTerr.value = [
    ...territorios.state.filteredTerr
  ]
})
</script>

<style scoped>
.options {
  margin-top: 10px;
  padding: 10px 0 p;
}
</style>